/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { checkToken } from '@builddocs/data-management'
import axios from 'axios'

export const SmartAssistantAPI = axios.create({
  baseURL: '/smart-assistant/api/v1',
})

SmartAssistantAPI.interceptors.request.use(
  config => {
    return checkToken(config)
  },
  error => {
    return Promise.reject(error)
  },
)
